module.exports = __webpack_public_path__ + "static/media/study 201117.00196fb0.png";